import { render } from "./BuyMarine.vue?vue&type=template&id=e6d2e998&scoped=true"
import script from "./BuyMarine.vue?vue&type=script&lang=js"
export * from "./BuyMarine.vue?vue&type=script&lang=js"

import "./BuyMarine.vue?vue&type=style&index=0&id=e6d2e998&scoped=true&lang=css"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6d2e998"]])

export default __exports__